/**
 * ZIFEK — Configuration plateforme de la dictée vocale (Whisper).
 *
 * La configuration (activation + langue par défaut) est gérée par le Super Admin
 * et lue via l'edge function sécurisée `transcribe-audio`. On la met en cache au
 * niveau du module afin que plusieurs champs équipés du micro sur une même page
 * ne déclenchent pas des appels réseau redondants.
 */

export interface VoiceConfig {
  enabled: boolean;
  language: string;
}

const FALLBACK: VoiceConfig = { enabled: false, language: 'auto' };

let cache: VoiceConfig | null = null;
let inflight: Promise<VoiceConfig> | null = null;

export function loadVoiceConfig(force = false): Promise<VoiceConfig> {
  if (!force && cache) return Promise.resolve(cache);
  if (!force && inflight) return inflight;

  const base = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string;
  const anon = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string;

  inflight = fetch(`${base}/functions/v1/transcribe-audio`, {
    method: 'POST',
    headers: { apikey: anon, Authorization: `Bearer ${anon}`, 'Content-Type': 'application/json' },
    body: JSON.stringify({ action: 'config' }),
  })
    .then((r) => r.json())
    .then((data: Record<string, unknown>) => {
      const cfg: VoiceConfig = {
        enabled: data?.enabled === true,
        language: typeof data?.language === 'string' ? data.language : 'auto',
      };
      cache = cfg;
      return cfg;
    })
    .catch(() => {
      cache = FALLBACK;
      return FALLBACK;
    })
    .finally(() => {
      inflight = null;
    });

  return inflight;
}